import { render } from "./theme20.vue?vue&type=template&id=03ac1c4f&scoped=true"
import script from "./theme20.vue?vue&type=script&lang=js"
export * from "./theme20.vue?vue&type=script&lang=js"

import "./theme20.vue?vue&type=style&index=0&id=03ac1c4f&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-03ac1c4f"

export default script